import { render, staticRenderFns } from "./DialogTbale.vue?vue&type=template&id=25d779ba&scoped=true&"
import script from "./DialogTbale.vue?vue&type=script&lang=js&"
export * from "./DialogTbale.vue?vue&type=script&lang=js&"
import style0 from "./DialogTbale.vue?vue&type=style&index=0&id=25d779ba&scoped=true&lang=scss&ref=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d779ba",
  null
  
)

export default component.exports